// import React, { useState } from 'react';
import '../App.css';
// import { dates } from '../utils/dates';
// import OpenAI from "openai"
// const polygonKey = '4WIejW1xiSt2MySvoid6IDNEaKv2ndkN';

const Home = () => {

  // const [tickerInput, setTickerInput] = useState('');
  // const [tickers, setTickers] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [reportOutput, setReportOutput] = useState('');
  // const [error, setError] = useState('');
  // const [apiMessage, setApiMessage] = useState('Querying Stocks API...');

  // const handleAddTicker = (e) => {
  //   e.preventDefault();
  //   if (tickerInput.length < 3) {
  //     setError('You must add at least one ticker. A ticker is a 3 letter or more code for a stock. E.g TSLA for Tesla.');
  //     return;
  //   }

  //   if (tickers.length >= 3) return;

  //   setTickers([...tickers, tickerInput.toUpperCase()]);
  //   setTickerInput('');
  //   setError('');
  // };

  // const fetchStockData = async () => {
  //   setLoading(true);
  //   setApiMessage('Querying Stocks API...');
  //   try {
  //     const stockData = await Promise.all(tickers.map(async (ticker) => {
  //       const url = `https://api.polygon.io/v2/aggs/ticker/${ticker}/range/1/day/${dates.startDate}/${dates.endDate}?apiKey=${polygonKey}`;
  //       const response = await fetch(url);
  //       const status = response.status;
  //       const data = await response.text();
  //       if (status === 200) {
  //         setApiMessage('Creating report...');
  //         return data;
  //       } else {
  //         throw new Error('Failed to fetch stock data');
  //       }
  //     }));

  //    fetchReport(stockData.join(''));
  //   } catch (err) {
  //     setApiMessage('There was an error fetching stock data.');
  //     console.error(err);
  //   }
  // };

  // const fetchReport = async (data) => {
  //   const messages = [
  //       {
  //           role: 'system',
  //           content: 'You are a trading guru. Given data on share prices over the past 3 days, write a report of no more than 150 words describing the stocks performance and recommending whether to buy, hold or sell.'
  //       },
  //       {
  //           role: 'user',
  //           content: data
  //       }
  //   ]

  //   try {
  //       const openai = new OpenAI({
  //           dangerouslyAllowBrowser: true,
  //           apiKey: process.env.REACT_APP_OPEN_AI_API_KEY ,
  //       })
  //       const response = await openai.chat.completions.create({
  //           model: process.env.REACT_APP_OPEN_AI_MODEL,
  //           messages: messages
  //       })
  //       renderReport(response.choices[0].message.content)

  //   } catch (err) {
  //       console.log('Error:', err)
  //       alert('Unable to access AI. Please refresh and try again')
  //   }
  // };

  // function renderReport(output) {
  //   // loadingArea.style.display = 'none'
  //   // const outputArea = document.querySelector('.output-panel')
  //   // const report = document.createElement('p')
  //   // outputArea.appendChild(report)
  //   // report.textContent = output
  //   setReportOutput(output)
  //   console.log('Report:', output)
  //   // console.log('Report:', reportOutput)
  //   // outputArea.style.display = 'flex'
  // }

  // return (
  //   <div className="App">
  //     <header>
  //       <img src="images/logo-dave-text.png" alt="Dodgy Dave's Stock Predictions" />
  //     </header>

  //     <main>
  //       {!loading && !reportOutput && (
  //         <section className="action-panel">
  //           <form onSubmit={handleAddTicker}>
  //             <label htmlFor="ticker-input" style={{ color: error ? 'red' : 'inherit' }}>
  //               {error || 'Add up to 3 stock tickers below to get a super accurate stock predictions report👇'}
  //             </label>
  //             <div className="form-input-control">
  //               <input
  //                 type="text"
  //                 id="ticker-input"
  //                 value={tickerInput}
  //                 onChange={(e) => setTickerInput(e.target.value)}
  //                 placeholder="MSFT"
  //               />
  //               <button className="add-ticker-btn" type="submit">
  //                 <img src="images/add.svg" className="add-ticker-svg" alt="add" />
  //               </button>
  //             </div>
  //           </form>

  //           <p className="ticker-choice-display">
  //             {tickers.length === 0
  //               ? 'Your tickers will appear here...'
  //               : tickers.map((ticker, idx) => (
  //                   <span className="ticker" key={idx}>{ticker}</span>
  //                 ))}
  //           </p>

  //           <button
  //             className="generate-report-btn"
  //             type="button"
  //             disabled={tickers.length === 0}
  //             onClick={fetchStockData}
  //           >
  //             Generate Report
  //           </button>

  //           <p className="tag-line">Always correct 15% of the time!</p>
  //         </section>
  //       )}

  //       {loading && (
  //         <section className="loading-panel">
  //           <img src="images/loader.svg" alt="loading" />
  //           <div id="api-message">{apiMessage}</div>
  //         </section>
  //       )}

  //       {reportOutput && (
  //         <section className="output-panel">
  //           <h2>Your Report 😜</h2>
  //           <p>{reportOutput}</p>
  //         </section>
  //       )}
  //     </main>

  //     <footer>
  //       &copy; This is not real financial advice!
  //     </footer>
  //   </div>
  // );
}

export default Home